<script lang="ts">
	import { formatPoints } from '$services/PointsFormatter';

	export let compensationAmount: number;
	export let loading: boolean = false;
	export let isHorizontal: boolean = false;

</script>

<div class="achievement-footer-container" class:oc-mt-75={!isHorizontal} data-testid="achievement-footer">
	{#if loading}
		<oc-icon-button-v2
			data-testid="loading"
			loading=""
			size="50"
		></oc-icon-button-v2>
		{:else}
		<div class="link oc-mr-25">
			Hol deine {formatPoints(compensationAmount)} Punkte ab
		</div>
		<oc-icon-v1 data-testid="icon" class="link" type="arrow-right" size="50"></oc-icon-v1>
	{/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .separator {
    border-top: 1px solid tokens.$oc-base-color-gray-100;
  }

  .centered {
    text-align: center;
  }

  .link {
    color: var(--oc-semantic-color-text-interactive);
    font: var(--oc-semantic-font-copy-100);
    text-align: center;
  }

  .achievement-footer-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>
